import { isSimpleError, SimpleError } from './SimpleError.js';
export function isSimpleErrors(e) {
    return typeof e === 'object' && e !== null && 'errors' in e && Array.isArray(e.errors) && e.errors.length > 0 && isSimpleError(e.errors[0]);
}
// Error that is caused by a client and should be reported to the client
export class SimpleErrors extends Error {
    constructor(...errors) {
        super(errors.map(e => e.message).join('\n'));
        this.errors = errors;
    }
    addError(error) {
        if (isSimpleError(error)) {
            this.errors.push(error);
            this.message += '\n' + error.toString();
        }
        else if (isSimpleErrors(error)) {
            this.errors.push(...error.errors);
            this.message += '\n' + error.toString();
        }
        else {
            throw new Error('Unsupported addError');
        }
    }
    unshiftError(error) {
        if (isSimpleError(error)) {
            this.errors.unshift(error);
            this.message += '\n' + error.toString();
        }
        else if (isSimpleErrors(error)) {
            this.errors.unshift(...error.errors);
            this.message += '\n' + error.toString();
        }
        else {
            throw new Error('Unsupported addError');
        }
    }
    get statusCode() {
        return this.errors.find(e => e.statusCode !== undefined)?.statusCode;
    }
    removeErrorAt(index) {
        this.errors.splice(index, 1);
    }
    addNamespace(field) {
        this.errors.forEach((e) => {
            e.addNamespace(field);
        });
    }
    /**
     * @deprecated Renamed to hasCode
     */
    containsCode(code) {
        return this.hasCode(code);
    }
    hasCode(code) {
        return this.errors.findIndex(e => e.hasCode(code)) !== -1;
    }
    getCode(code) {
        return this.errors.find(e => e.hasCode(code));
    }
    /**
     * @deprecated Renamed to hasFieldThatStartsWith
     */
    containsFieldThatStartsWith(prefix) {
        return this.hasFieldThatStartsWith(prefix);
    }
    hasFieldThatStartsWith(prefix) {
        return this.errors.findIndex(e => e.hasFieldThatStartsWith(prefix)) !== -1;
    }
    /**
     * Required to override the default toJSON behaviour of Error
     */
    toJSON() {
        return this.encode({ version: 0 });
    }
    encode(context) {
        return {
            errors: this.errors.map(e => e.encode(context)),
        };
    }
    static decode(data) {
        return new SimpleErrors(...data.field('errors').array(SimpleError));
    }
    throwIfNotEmpty() {
        if (this.errors.length > 0) {
            if (this.errors.length == 1) {
                throw this.errors[0];
            }
            throw this;
        }
    }
    get human() {
        return this.getHuman();
    }
    /// Returns a human description of all the errors
    getHuman() {
        return this.errors
            .filter(e => !!e.getHuman())
            .map(e => e.getHuman())
            .join('\n');
    }
}
//# sourceMappingURL=SimpleErrors.js.map